"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RotatedUrlOut = void 0;
class RotatedUrlOut {
    constructor() {
    }
    static getAttributeTypeMap() {
        return RotatedUrlOut.attributeTypeMap;
    }
}
exports.RotatedUrlOut = RotatedUrlOut;
RotatedUrlOut.discriminator = undefined;
RotatedUrlOut.attributeTypeMap = [
    {
        "name": "url",
        "baseName": "url",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=RotatedUrlOut.js.map